module.exports = __webpack_public_path__ + "media/images/common/avatar1-dc3d19bc95b3a1e31118006c1a2d7943.png";